<template>
  <template v-if="fitCarouselToScreen">
    <div class="justify-items-center">
      <div class="w-full max-w-[2688px] px-24">
        <component
          :is="mobileComponent"
          v-bind="propsWithoutLayout"
          class="flex md:hidden"
        />

        <component
          :is="desktopComponent"
          v-bind="propsWithoutLayout"
          class="hidden md:flex"
        />
      </div>
    </div>
  </template>

  <template v-else>
    <component
      :is="mobileComponent"
      v-bind="propsWithoutLayout"
      class="flex md:hidden"
    />

    <component
      :is="desktopComponent"
      v-bind="propsWithoutLayout"
      class="hidden md:flex"
    />
  </template>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { ModularCardsCollectionApiProps } from '@backmarket/http-api/src/api-specs-content/models/modular-card'

import type { BlockProps } from '../../models/content-block'

import ModularCardsCarousel from './ModularCardsCarousel.vue'
import ModularCardsGrid from './ModularCardsGrid.vue'

export type ModularCardsCollectionBlockProps = ModularCardsCollectionApiProps &
  BlockProps

const props = withDefaults(defineProps<ModularCardsCollectionBlockProps>(), {
  cardsHavePadding: true,
  layout: 'carousel',
  desktopLayout: 'carousel',
})

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error', 'reset-error'])

const propsWithoutLayout = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { layout, desktopLayout, ...rest } = props

  return rest
})

const fitCarouselToScreen = computed(() => {
  return !!props.fitToScreen && props.desktopLayout === 'carousel'
})

const mobileComponent = computed(() => {
  return props.layout === 'grid' ? ModularCardsGrid : ModularCardsCarousel
})

const desktopComponent = computed(() => {
  return props.desktopLayout === 'grid'
    ? ModularCardsGrid
    : ModularCardsCarousel
})
</script>
